import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.INIT = function (state, payload) {
  state.validations = payload.validation
}
mutations.SEARCH = function (state, payload) {
  state.userList = payload.results
}
mutations.DETAIL = function (state, payload) {
  state.userDetails = payload.results
}
mutations.CLEAR = function (state, payload) {
  state.userList = []
}

const state = {
  userList: [],
  userDetails: null,
  validations: {}
}
const actions = {
  init: ({ commit, state }, cond) => {
    console.debug('called M0001User init')
    return client.postData({ data: { init: { api: 'M0101UserService.getInit', input: cond } } })
      .then((data) => {
        if (data.init.output.status === false) { throw new Error(data.init.output.message) } else {
          commit('INIT', data.init.output)
        }
      }).catch((err) => { throw err })
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0001User search')
    return client.postData({ data: { search: { api: 'M0101UserService.searchUser', input: condition } } })
      .then((data) => {
        if (data.search.output.status === false) { throw new Error(data.search.output.message) } else {
          commit('SEARCH', { results: data.search.output })
        }
      }).catch((err) => { throw err })
  },
  detail: ({ commit, state }, condition) => {
    console.debug('called M0001User detail')
    return client.postData({ data: { detail: { api: 'M0101UserService.getDetail', input: condition } } })
      .then((data) => {
        if (data.detail.output.status === false) { throw new Error(data.detail.output.message) } else {
          commit('DETAIL', { results: data.detail.output })
        }
      }).catch((err) => { throw err })
  },
  edit: ({ commit, state }, condition) => {
    console.debug('called M0001User edit')
    return client.postData({ data: { edit: { api: 'M0101UserService.editUser', input: condition } } })
      .then((data) => {
        if (data.edit.output.status === false) { throw new Error(data.edit.output.message) } else {
          return data.edit.output
        }
      }).catch((err) => { throw err })
  },
  delete: ({ commit, state }, condition) => {
    console.debug('called M0001User delete')
    return client.postData({ data: { delete: { api: 'M0101UserService.deleteUser', input: condition } } })
      .then((data) => {
        if (data.delete.output.status === false) { throw new Error(data.delete.output.message) } else {
          return data.delete.output
        }
      }).catch((err) => { throw err })
  },
  clear: ({ commit, state }, condition) => {
    console.debug('called M0001User clear')
    commit('CLEAR')
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
